import { createAction } from 'redux-actions';

export const SET_LOADING = 'SET_LOADING';

export const setLoading = createAction(SET_LOADING);
